// The server resolves who may authorize this action from persisted profile settings.
export const profilePinAuthority = (target, current, profiles, editing = false) => {
  if (!target) return null;
  const field = editing ? "editPinProfileId" : "selectionPinProfileId";
  if (Object.prototype.hasOwnProperty.call(target, field)) return target[field] || null;
  // Compatibility while refreshing a profile list saved by an older client.
  if ((editing && (target.kid || current?.kid)) || (!editing && current?.kid && !target.kid)) {
    return profiles?.find(entry => entry.main && !entry.kid)?.id || "parent";
  }
  return target.hasPin ? target.id : null;
};
